import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'

const AuthLayout = () => {
  const getUser = JSON.parse(sessionStorage.getItem('userInfo'))

  return !getUser ? (
    <div>
      <Outlet />
    </div>
  ) : (
    <Navigate to={'/auth/login'} />
  )
}

export default AuthLayout
